<template>
  <div>
    <el-row style="margin: 0px 0px 0px 400px;" v-if="operationList.length > 0">
      <span :key="index" v-for="(item,index) in operationList">
        <el-button :disabled="!isControl" @touchstart="() => change(item.id,item.value)"  @click="() => change(item.id,item.value)" size="mini"
                   style="margin-right: 5px;display: inline-block;margin-top: 5px;"
                   :style="{backgroundColor: 'rgba(41, 155, 255, .5)'}"
                   v-if="item.type === 'button'">{{ item.name }}</el-button>
      </span>
    </el-row>

  </div>
</template>

<script>
import {listByModelIdAndDeviceId} from "@/network/device-model-control";
import {passwordVerifiers} from "@/network/account";
import {getCookie, setCookie} from "@/utils/common";
import {ParkingGateControl} from "@/network/car-access";

export default {
  name: "GateControl",
  props: ['deviceInfo','code'],
  data() {
    return {
      operationList: [],
      isControl: true,
      operationCodes: [],
      controlList: [],
      pointList: [],
    }
  },
  mounted() {
    this.listByModelIdAndDeviceId();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getControlData:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getControlData')
  },
  methods: {
    listByModelIdAndDeviceId() {
      listByModelIdAndDeviceId(this.deviceInfo.modelId, this.deviceInfo.id).then(res => {
        if (res.data) {
          this.controlList = res.data.modelControls;
          this.isControl = res.data.isControl;
          this.controlList.forEach(list => {
            this.operationList.push(list);
          })
        }
      })
    },
    change(id, valueBut) {
      console.log(this.code,"this.gateId");
      if (getCookie("passwordVerification") === '1') {
        ParkingGateControl(this.code, valueBut).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: res.message
            });
          }else{
            this.$message({
              type: 'error',
              message: res.message
            });
          }
          this.$emit("control")
        })
      } else {
        this.$prompt('请输入系统登录密码确认身份', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
        }).then(({value}) => {
          passwordVerifiers(value).then(res => {
            if (res.data === true) {
              setCookie("passwordVerification", '1', null);
              ParkingGateControl( this.code, valueBut).then(res => {
                if (res.code === 0) {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  });
                }else{
                  this.$message({
                    message: res.message,
                    type: 'error'
                  });
                }
                this.$emit("control")
              })
              this.functionDialogVisible = false;
            } else {
              this.$message({
                message: '系统登录密码错误',
                type: 'warning'
              });
              return;
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }
    },
  }
}
</script>
<style scoped>
</style>
